import { useMemo } from "react";
import { Project } from "@brg/api";
import { FtblMatchInfo } from "../../../../pages/project/components/ftbl/ftblMatchInfo.types";
import { parseFtblMatchInfo } from "../../../../pages/project/components/ftbl/parseFtblMatchInfo";
import { FtblCoverImageInner, FtblCoverImageWrapper } from "./styles";
import { TeamWithScore } from "./TeamWithScore";
import { TeamWithoutScore } from "./TeamWithoutScore";

const FtblCoverImage = ({ project }: { project: Project<'Local'> | Project<'Global'> }) => {
    const matchInfo = useMemo<FtblMatchInfo | null>(() => parseFtblMatchInfo(project?.additionalInfo?.MatchInfo), [project]);

    if (!matchInfo) return null;

    const hasScore = matchInfo.HomeTeamScore !== null && matchInfo.GuestTeamScore !== null;

    return <FtblCoverImageWrapper>
        <FtblCoverImageInner>
            {hasScore
                ? <>
                    <TeamWithScore
                        name={matchInfo.HomeTeamName}
                        score={matchInfo.HomeTeamScore}
                        flagCountryId={matchInfo.HomeTeamCountryId}
                    />
                    <TeamWithScore
                        name={matchInfo.GuestTeamName}
                        score={matchInfo.GuestTeamScore}
                        flagCountryId={matchInfo.GuestTeamCountryId}
                        isReverse
                    />
                </>
                : <TeamWithoutScore matchInfo={matchInfo} />
            }
        </FtblCoverImageInner>
    </FtblCoverImageWrapper>
}

export default FtblCoverImage;
import { useMemo } from "react";
import { Project } from "@brg/api";
import { FtblMatchInfo } from "../../../../pages/project/components/ftbl/ftblMatchInfo.types";
import { parseFtblMatchInfo } from "../../../../pages/project/components/ftbl/parseFtblMatchInfo";
import { FtblCoverImageInner, FtblCoverImageWrapper } from "./styles";
import { TeamWithScore } from "./TeamWithScore";
import { TeamWithoutScore } from "./TeamWithoutScore";

const FtblCoverImage = ({ project }: { project: Project<'Local'> | Project<'Global'> }) => {
    const matchInfo = useMemo<FtblMatchInfo | null>(() => parseFtblMatchInfo(project?.additionalInfo?.MatchInfo), [project]);

    if (!matchInfo) return null;

    const hasScore = matchInfo.HomeTeamScore !== null && matchInfo.GuestTeamScore !== null;

    return <FtblCoverImageWrapper>
        <FtblCoverImageInner>
            {hasScore
                ? <>
                    <TeamWithScore
                        name={matchInfo.HomeTeamName}
                        score={matchInfo.HomeTeamScore}
                        flagCountryId={matchInfo.HomeTeamCountryId}
                    />
                    <TeamWithScore
                        name={matchInfo.GuestTeamName}
                        score={matchInfo.GuestTeamScore}
                        flagCountryId={matchInfo.GuestTeamCountryId}
                        isReverse
                    />
                </>
                : <TeamWithoutScore matchInfo={matchInfo} />
            }
        </FtblCoverImageInner>
    </FtblCoverImageWrapper>
}

export default FtblCoverImage;
